import { NgModule } from '@angular/core';
import { LocationSwitcherComponent } from './location-switcher.component';

@NgModule({
  imports: [LocationSwitcherComponent],
  exports: [LocationSwitcherComponent],
})
export class LocationSwitcherModule {}
